var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLookahead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 10,
    height: 3,
    rx: 1,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7678 11.7322C13.963 11.537 14.2796 11.537 14.4749 11.7322L15.8891 13.1464C16.0844 13.3417 16.0844 13.6583 15.8891 13.8535L14.4749 15.2677C14.2796 15.463 13.963 15.463 13.7678 15.2677L12.3536 13.8535C12.1583 13.6583 12.1583 13.3417 12.3536 13.1464L13.7678 11.7322Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 16,
    height: 3,
    rx: 1,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4V13.5H14",
    stroke: "#000000",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.5H4.5",
    stroke: "#000000",
    strokeWidth: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLookahead);
export default __webpack_public_path__ + "static/media/icon--lookahead.0b6d7861763a3df13e0a5e05d1d4f6a4.svg";
export { ForwardRef as ReactComponent };